exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".jumbotron {\n  text-align: center;\n  color: #fff;\n  background: -webkit-linear-gradient(top, #004d7c 0%, #005c94 21%, #005c94 100%);\n  background: linear-gradient(to bottom, #004d7c 0%, #005c94 21%, #005c94 100%);\n  padding: 0 2rem;\n  margin: 0;\n  border-top: 1px solid #fff; }\n\n.jumbotron .row {\n  background-image: url(" + require("../../assets/images/flower.png") + ");\n  background-repeat: no-repeat;\n  background-position: center; }\n\n.jumbotron__logo {\n  background-image: url(" + require("../../assets/images/logo.png") + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 200px;\n  min-width: 400px; }\n\n.jumbotron__body {\n  margin: 0;\n  padding: 16px 0; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./client/app/components/jumbotron/jumbotron.scss
 ** module id = 30
 ** module chunks = 0
 **/